import type { ReactNode } from 'react';

import type { CouponIndex } from '../../schema/coupon/entry.js';

type CouponSelectionProps = {
  price: number;
  numberOfCoupons: number;
  couponIndex: CouponIndex;
};

/**
 * Component that renders the coupon selection.
 *
 * @param root0 props for the component
 * @param root0.price price of the given coupon
 * @param root0.numberOfCoupons number of coupons available
 * @param root0.couponIndex index of the coupon to render
 * @returns component that renders the coupon selection
 */
export default function CouponSelection({ price, numberOfCoupons, couponIndex }: CouponSelectionProps): ReactNode {
  return (
    <div className="min-w-10 p-1 text-center whitespace-nowrap">
      <span>
        {numberOfCoupons < 3 ? `Kupong ` : ``}
        {couponIndex + 1}
      </span>
      {numberOfCoupons < 5 && <span> - {price} kr</span>}
    </div>
  );
}
